// Using import() would be ideal, but for now we'll use a type assertion with require
// eslint-disable-next-line @typescript-eslint/no-require-imports
const RailsExportedConfig = require('./rails_constants.json.erb');
export default RailsExportedConfig;
